import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const BOOK_SLOT = apiPromiseTypes('bookslot', 'post');
export const SLOT_DAYS = apiPromiseTypes('slotdays', 'post');
export const SET_SLOTS_DISABLED = 'waitrose/slots/SET_SLOTS_DISABLED';
export const SET_BOOKING_SLOT_ID = 'waitrose/slots/SET_BOOKING_SLOT_ID';
